/**
 * Intelligence Persona (Axis 1) — the persona a User holds inside an Intelligence Organization,
 * persisted on `UserCompany.persona` for memberships in `CompanyType.INTELLIGENCE` companies.
 *
 * Distinct from the platform `UserAccessRole` (Innovator/Expert/Intelligence/Admin), from the
 * generic `UserCompanyRole` (Admin/Collaborator), and from a Study Role (Axis 2). Governs baseline
 * authority inside the organization. See docs/adr/0007 and the User & Roles spec (Axis 1).
 */
export var IntelligencePersona;
(function (IntelligencePersona) {
    IntelligencePersona["DECISION_MAKER"] = "DECISION_MAKER";
    IntelligencePersona["LIBRARIAN"] = "LIBRARIAN";
    IntelligencePersona["MISSION_ENGINEER"] = "MISSION_ENGINEER";
    IntelligencePersona["PROGRAM_ADMIN"] = "PROGRAM_ADMIN";
})(IntelligencePersona || (IntelligencePersona = {}));
/**
 * Personas that may create and own Studies (become the Author/Lead). Single-sourced rule enforced
 * server-side and mirrored by the web for UX. Librarian and Decision Maker cannot create studies.
 */
export const STUDY_CREATING_PERSONAS = [
    IntelligencePersona.MISSION_ENGINEER,
    IntelligencePersona.PROGRAM_ADMIN,
];
/** Whether a persona may create/own Studies. */
export function canPersonaCreateStudies(persona) {
    return persona != null && STUDY_CREATING_PERSONAS.includes(persona);
}
/** Whether a persona may manage their organization's members and personas (Program Admin only). */
export function canPersonaManageOrgTeam(persona) {
    return persona === IntelligencePersona.PROGRAM_ADMIN;
}
